import { render } from "./RadiobuttonElement.vue?vue&type=template&id=6b9d40c2&scoped=true"
import script from "./RadiobuttonElement.vue?vue&type=script&lang=js"
export * from "./RadiobuttonElement.vue?vue&type=script&lang=js"

import "./RadiobuttonElement.vue?vue&type=style&index=0&id=6b9d40c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b9d40c2"]])

export default __exports__